
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-information",
      function () {
        return require("private-next-pages/news-and-information/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-information"])
      });
    }
  